import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { IGetState } from '../../../../../../../types/types';
import { CLASS_ASIDE_PANEL_BODY } from '../../../components/AsidePanelBody/constants';
import { SegmentAsidePanelEvent, segmentTrackAction } from '../../../../../../../middlewares/segment';
import { getCurrentRoute } from '../../../../../../../store/router/selectors/getCurrentRoute';
import { ERoutes } from '../../../../../../../store/router/constants';

export const onClick = (
    route: ERoutes,
    onClickOwn: () => ThunkAction,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (onClickOwn) {
            dispatch(onClickOwn());
        } else {
            if (route !== getCurrentRoute(getState())) return;
            const tab = document.querySelector('.' + CLASS_ASIDE_PANEL_BODY) as HTMLElement;
            if (tab) {
                tab.scroll({ behavior: 'smooth', top: 0 });
                dispatch(segmentTrackAction(SegmentAsidePanelEvent.SCROLL_TOP_BY_TAB_CLICK));
            }
        }
    };
    return action;
};
